import { ContainerModule, interfaces } from 'inversify';
import { IUpdateWorkspaceTimeZoneService, UpdateWorkspaceTimeZoneService } from './sub/UpdateWorkspaceTimeZone/services/UpdateWorkspaceTimeZone.service';
import { IUpdateWorkspaceTimeZoneBl, UpdateWorkspaceTimeZoneBl } from './sub/UpdateWorkspaceTimeZone/UpdateWorkspaceTimeZone.bl';
import { IUpdateWorkspaceTimeZoneStore, UpdateWorkspaceTimeZoneStore } from './sub/UpdateWorkspaceTimeZone/UpdateWorkspaceTimeZone.store';
import { IWorkspacesPermissions, WorkspacesPermissions } from './workspaces.permissions';
import { IWorkspaceService, WorkspaceService } from './workspaces.service';
import { IWorkspacesStore, WorkspacesStore } from './workspaces.store';

export const workspacesModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IWorkspacesStore.$).to(WorkspacesStore).inSingletonScope();
  bind(IWorkspaceService.$).to(WorkspaceService).inSingletonScope();
  bind(IUpdateWorkspaceTimeZoneBl.$).to(UpdateWorkspaceTimeZoneBl).inSingletonScope();
  bind(IUpdateWorkspaceTimeZoneStore.$).to(UpdateWorkspaceTimeZoneStore).inSingletonScope();
  bind(IUpdateWorkspaceTimeZoneService.$).to(UpdateWorkspaceTimeZoneService).inRequestScope();
  bind(IWorkspacesPermissions.$).to(WorkspacesPermissions).inSingletonScope();
});
